import type { Mouvement } from '@mairistem/comptabilite';
import BordereauStateStep from '../../../constants/liquidation/bordereaux/BordereauStateStep';
import BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import type BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type MouvementActionType from '../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import BordereauActualiseEtatAction from '../actions/BordereauActualiseEtatAction';
import BaseBordereauState from './BaseBordereauState';

class BordereauAttenteTransmissionParapheurState extends BaseBordereauState {
	constructor() {
		super();
		this.step = BordereauStateStep.ATTENTE_TRANSMISSION_PARAPHEUR;
		this.state = BordereauStateType.ATTENTE_TRANSMISSION_PARAPHEUR;
		this.color = '#000d8c';
		this.libelle = 'Attente transmission parapheur';
	}

	getBordereauActions(
		_bordereau: BordereauWithState,
	): BaseLiquidationAction<BordereauWithState, BordereauActionType>[] {
		return [new BordereauActualiseEtatAction({ isActionPrincipale: true })];
	}

	getMouvementActions(): BaseLiquidationAction<
		Mouvement,
		MouvementActionType
	>[] {
		return [];
	}
}

export default BordereauAttenteTransmissionParapheurState;
